import { useEffect } from 'react'
import { trackEvent } from '@/src/analytics/amplitude'

export const useTrackSection = () => {
  useEffect(() => {
    trackEvent('START_SECTION')

    return () => {
      trackEvent('END_SECTION')
    }
  }, [])
}
